import { JOB_NAME } from "../../../constants/jobs";

export const mapLanguagesToOptions = (languages) =>
  languages.map((language) => ({ label: language.name, value: language }));

export const buildClearCsvImportedDataJob = (languageShort) => ({
  job_name: JOB_NAME.CLEAR_CSV_IMPORTED_DATA,
  arguments_passed: JSON.stringify({
    languageShort,
  }),
});

export const getJobErrorMessage = (error) =>
  error?.response?.data?.message || "Something went wrong";
